import { Link } from "react-router-dom";
import { Scale, ArrowLeft, ShieldCheck, Trash2, Cpu, UserCheck } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import LanguageToggle from "@/components/LanguageToggle";

function Block({ icon: Icon, title, points }) {
  return (
    <section className="mt-8">
      <h2 className="flex items-center gap-2 font-serif-display text-xl font-normal text-zinc-100">
        <Icon className="h-5 w-5 text-[#d4af37]" strokeWidth={1.5} /> {title}
      </h2>
      <ul className="mt-3 space-y-2">
        {points.map((p, i) => (
          <li key={`p-${i}`} className="flex items-start gap-2.5 text-[15px] leading-relaxed text-zinc-300">
            <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#d4af37] shrink-0" />
            {p}
          </li>
        ))}
      </ul>
    </section>
  );
}

export default function PrivacyPolicy() {
  const { t } = useI18n();
  return (
    <div className="min-h-screen bg-[#0a0a0c] text-zinc-100">
      <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#0a0a0c]/80 border-b border-white/5">
        <div className="mx-auto max-w-3xl px-6 h-16 flex items-center justify-between">
          <Link to="/" data-testid="privacy-back" className="flex items-center gap-2 text-zinc-400 hover:text-zinc-100 transition-colors">
            <ArrowLeft className="h-4 w-4" />
            <Scale className="h-5 w-5 text-[#d4af37]" strokeWidth={1.5} />
            <span className="font-mono-ui text-sm tracking-[0.2em] uppercase">Lexiqa</span>
          </Link>
          <LanguageToggle />
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-6 py-14" data-testid="privacy-page">
        <p className="font-mono-ui text-[11px] uppercase tracking-[0.15em] text-[#d4af37]">
          <ShieldCheck className="inline h-4 w-4 mr-1" /> {t("privacy.updated")}
        </p>
        <h1 className="mt-3 font-serif-display text-4xl font-light text-zinc-50">{t("privacy.title")}</h1>
        <p className="mt-4 text-[15px] leading-relaxed text-zinc-400">{t("privacy.intro")}</p>

        <Block icon={Trash2} title={t("privacy.s1t")}
          points={[t("privacy.s1a"), t("privacy.s1b"), t("privacy.s1c"), t("privacy.s1d")]} />
        <Block icon={Cpu} title={t("privacy.s2t")}
          points={[t("privacy.s2a"), t("privacy.s2b"), t("privacy.s2c"), t("privacy.s2d")]} />
        <Block icon={UserCheck} title={t("privacy.s3t")} points={[t("privacy.s3a")]} />
        <Block icon={ShieldCheck} title={t("privacy.s4t")} points={[t("privacy.s4a")]} />
        <Block icon={ShieldCheck} title={t("privacy.s5t")} points={[t("privacy.s5a")]} />

        <Link to="/" className="mt-12 inline-flex items-center gap-1.5 font-mono-ui text-[11px] uppercase tracking-wider text-[#d4af37] hover:text-[#e6c04d] transition-colors">
          <ArrowLeft className="h-3.5 w-3.5" /> {t("privacy.backHome")}
        </Link>
      </main>
    </div>
  );
}
